import { Fragment, useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import { useTranslation } from "react-i18next";
import useAxios from "../../../hook/useAxios";
import ActionItem from "../../Global/ActionItem";
import { toast } from "react-toastify";
import { GrowthStage } from "../../../type/growthStage";
import WarningRedAlert from "../../ErrorAndAlert/WarningRedAlert";
import { defaultLang } from "../../../utils";

const BotanicalFamilyTableItem: React.FC<{
  botanicalFamilies: GrowthStage;
  editLink: string;
  link: string;
  deleteMessage: string;
  title: string;
  featured_icon?: string;
  fetchData: () => void;
}> = ({
  botanicalFamilies,
  editLink,
  link,
  deleteMessage,
  title,
  featured_icon,
  fetchData: propFetchData,
}) => {
  const { i18n, t } = useTranslation();
  const [showDelete, isShowDelete] = useState<boolean>(false);
  const { response: deleteR, fetchData } = useAxios(
    process.env.REACT_APP_API_URL + `${link}/${botanicalFamilies?.id}/delete/`,
    "DELETE",
    false,
    `${t("Message.The record deleted successfully")}`,
    true,
    true
  );
  useEffect(() => {
    if (deleteR !== null) {
      isShowDelete(false);
      propFetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteR]);

  const deleteAction = () => {
    if (botanicalFamilies?.is_deletable) {
      isShowDelete(true);
    } else {
      toast.error(deleteMessage);
    }
  };

  const hide = () => {
    isShowDelete(false);
  };

  const deleteItem = () => {
    fetchData({});
  };

  const incident =
    botanicalFamilies.name_transes?.[i18n.language] ||
    botanicalFamilies.name_transes?.[defaultLang];

  const desc =
    botanicalFamilies.description_transes?.[i18n.language] ||
    botanicalFamilies.description_transes?.[defaultLang];

  const isActive =
    botanicalFamilies.is_active_transes?.[i18n.language] ||
    botanicalFamilies.is_active_transes?.[defaultLang];

  return (
    <Fragment>
      <TableCell align="left">{incident}</TableCell>
      <TableCell align="left">
        <div className="max-w-[600px]">{desc}</div>
      </TableCell>
      {link.includes("incidents") && (
        <TableCell align="center">
          {featured_icon && (
            <div className="flex justify-center">
              <img
                src={featured_icon}
                alt="incident"
                className="w-[14px] h-[14px] mr-3 object-cover"
              />
            </div>
          )}
        </TableCell>
      )}
      <TableCell>
        {title !== t("Tree Species.Botanical family") && (
          <p
            className={`${
              botanicalFamilies.is_active_transes[defaultLang] === "Activo"
                ? "bg-ph-toggle-bg-green text-ph-toggle-text-green"
                : "bg-ph-toggle-bg-red text-ph-red-warning"
            } text-center w-16 py-1 rounded-xl`}
          >
            {isActive}
          </p>
        )}
      </TableCell>
      <TableCell align="right">
        <ActionItem
          delete={true}
          editLink={`${editLink}/${botanicalFamilies?.slug}`}
          deleteAction={deleteAction}
          view=""
          viewLink=""
          historyLink=""
          viewHistory=""
        />
      </TableCell>
      {showDelete && (
        <WarningRedAlert
          type={title}
          hide={hide}
          action={deleteItem}
          isDelete={true}
          isSignOut={false}
        />
      )}
    </Fragment>
  );
};

export default BotanicalFamilyTableItem;
